import React from 'react';
import Particle from './../../Particle'; //eslint-disable-line no-unused-vars
import {Paragraph, Title} from './../../Basics';

const Particle02 = () => (<div>

  <Title>Die sechs Disziplinen des Cybathlon</Title>

  <Title level={3}>1. Parcours mit Exoskeletten</Title>
  <Paragraph>
    Exoskelette sind robotische Stützstrukturen, welche an den Beinen befestigt sind. Damit können
    Querschnittgelähmte aufrecht stehen, gehen und sogar Treppen steigen – allerdings sehr langsam.
    Auch das Gleichgewicht zu halten ist schwierig.
  </Paragraph>

  <Particle
    number={15}
  />
                          
  <Title level={3}>2. Geschicklichkeitsparcours mit Armprothesen</Title>
  <Paragraph>
    Hierbei traten Teilnehmer an, denen einer oder beide Arme fehlen und die 
    Hightech-Prothesen tragen. Mit diesen mussten sie unter anderem Getränkekisten 
    über eine Treppe tragen, eine Glühbirne einschrauben, den Tisch decken und 
    Wäsche aufhängen.
  </Paragraph>
   
  <Particle
    number={12}
  />

  <Title level={3}>3. Virtuelles Rennen mit Gedankensteuerung</Title>
  <Paragraph>
    Die Piloten und Pilotinnen dieses Rennens sind vollständig gelähmt. 
    Ihre Aufgabe war, allein mit der Kraft ihrer Gedanken die Figuren in einem Computerspiel zu steuern. 
    Das funktioniert über eine sogenannte Hirn-Computer-Schnittstelle.
  </Paragraph>
                          
  <Particle
    number={19}
  />

  <Title level={3}>4. Fahrradrennen mit Muskelstimulation</Title>
  <Paragraph>
      Bei Querschnittsgelähmten sind die Nerven im Rückenmark geschädigt, sodass sie
      ihre Beine nicht mehr bewegen können. Die Beinmuskeln sind aber intakt. Sie können
      über Elektroden auf der Haut stimuliert und so zur Kontraktion gebracht werden. Im 
      Fahrradrennen konnten die Fahrer die Stromzufuhr zu ihren Muskeln
      selbst steuern, während sie so schnell wie möglich die 750 Meter lange
      Rennstrecke fuhren.
  </Paragraph>

  <Particle
    number={24}
  />
                          
    <Title level={3}>5. Parcours mit motorisierten Rollstühlen</Title>
  <Paragraph>
      Rollstuhlfahrer kämpfen jeden Tag mit Treppen, Türschwellen und anderen 
      Hindernissen. Solche waren im Parcours nachgebaut. Die Fahrer mussten sie 
      mit motorisierten Rollstühlen überwinden, die per Joystick,
      Touchpad oder mit anderen Technologien gesteuert werden.
  </Paragraph>
 
  <Particle
    number={9}
  />
  
  <Title level={3}>6. Geschicklichkeitsparcours mit Beinprothesen</Title>
  <Paragraph>
    Bei dieser Disziplin mussten die Träger der Beinprothesen verschiedene 
    Schrittfolgen und Bewegungen durchführen, die nur geschickte Piloten mit 
    hochtechnologisierten Prothesen meistern konnten.
  </Paragraph>
                          
</div>);

export default Particle02;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle02/Particle02.js
 **/